export default {
  'permissions.admin': 'Administrator',
  'permissions.developer': 'Developer',
  'permissions.methodologist': 'Methodologist',
  'permissions.user': 'User',
  'permissions.current': 'Position permissions',
  'permissions.none': 'The backend does not send permissions yet',
  'permissions.sections': 'Available sections',
  'permissions.sections.all': 'All sections',
  'permissions.preview.label': 'Preview the interface for other permissions',
  'permissions.preview.actual': 'As in profile',
  'permissions.preview.hint':
    'Changes the interface layout on this device only. The token and server-side checks stay the same.',
  'permissions.preview.active':
    'The interface is built for the selected permissions. Received from the backend: {actual}.',
  'permissions.welcome.frameTitle': 'Access and interface',
};
